import { IconButton, Menu, MenuItem } from '@material-ui/core';
import { KeyboardArrowDown as HardwareKeyboardArrowDown } from '@material-ui/icons';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { BASELINE_SEARCH_SORT_RANK, canUpdateSearch } from 'shared/models/search';

import { useModal } from '../hooks/use-modal';

import { useSession } from '../hooks/use-session';
import { Job, Search, SearchStatus } from '../state';

interface JobSearchesTitleProps {
    onCloneSearch: (data: Search) => void;
    onUpdateSearch: (id: string, updates: Partial<Search>, refetchSearches: boolean) => void;
    onDeleteSearch: (data: Search) => void;
    onSearchClick?: (searchId: string) => void;
    search: Search;
    job: Job;
    name?: string;
    isCampaign?: boolean;
}

export const JobSearchesTitle: React.FC<JobSearchesTitleProps> = (props) => {
    const [menuAnchor, setMenuAnchor] = React.useState<HTMLElement | null>(null);
    const { getConfirmation } = useModal();
    const { user, userPermissions } = useSession();
    const canEdit = canUpdateSearch(props.search, user.id, userPermissions, props.job?.accountManagerId);

    const handleOnCloneSearch = () => {
        setMenuAnchor(null);
        props.onCloneSearch(props.search);
    };

    const handlePauseSearch = () => {
        props.onUpdateSearch(props.search.id, { status: SearchStatus.Paused }, false);
        setMenuAnchor(null);
    };

    const handleDeleteSearch = () => {
        getConfirmation(
            () => {
                props.onDeleteSearch(props.search);
                setMenuAnchor(null);
            },
            'This will delete the Search and all associated Search results',
            'Please confirm'
        );
    };

    const handleSearchClick = () => {
        if (props.onSearchClick) {
            props.onSearchClick(props.search.id);
        }
    };

    const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        setMenuAnchor(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setMenuAnchor(null);
    };

    const { search, name, job, isCampaign } = props;
    let menuButton: JSX.Element;

    let actionMenu: JSX.Element;
    if (search) {
        const pauseSearchItem =
            canEdit && [SearchStatus.Active, SearchStatus.ScoringFailed].includes(search.status) ? (
                <MenuItem dense={true} onClick={handlePauseSearch}>
                    Pause Search
                </MenuItem>
            ) : null;
        const deleteSearchItem =
            search.sortRank === BASELINE_SEARCH_SORT_RANK && user.id === job.accountManagerId ? (
                <MenuItem dense={true} onClick={handleDeleteSearch}>
                    Delete Search
                </MenuItem>
            ) : null;
        actionMenu = (
            <Menu open={Boolean(menuAnchor)} onClose={handleCloseMenu} anchorEl={menuAnchor}>
                <MenuItem dense={true} onClick={handleOnCloneSearch} disabled={Boolean(props.search.importRequestId)}>
                    Clone Search
                </MenuItem>
                {pauseSearchItem}
                {deleteSearchItem}
            </Menu>
        );
        menuButton = (
            <div className="job-search-actions">
                <IconButton onClick={handleMenuClick}>
                    <HardwareKeyboardArrowDown />
                </IconButton>
            </div>
        );
    }

    const content =
        search && !isCampaign ? (
            <Link to={`/job/${search.jobId}/search/${search.id}/total`}>{name || search.name}</Link>
        ) : (
            name
        );

    return (
        <div className="job-search-title">
            <div className="job-search-title-label" onClick={handleSearchClick}>
                {content}
            </div>
            {menuButton}
            {actionMenu}
        </div>
    );
};
